import moment from "moment-mini";
import i18n from "../i18n";

export const getDateTimeFormat = () => (i18n.locale === 'hu' ? "YYYY.MM.DD HH:mm:ss" : "DD/MM/YYYY HH:mm:ss");
export const getDateFormat = () => (i18n.locale === 'hu' ? "YYYY.MM.DD" : "DD/MM/YYYY");

export const formatDate = (obj, field) => {
  if (!obj || !obj[field]) {
    return;
  }
  // parse specified format or ISO_8601
  const momentObj = moment(obj[field], [getDateTimeFormat(), moment.ISO_8601]);
  if (momentObj.isValid()) {
    // format to specified format
    obj[field] = momentObj.format(getDateTimeFormat());
  }
};

export const dateText = (value) => {
  // parse specified format or ISO_8601
  const momentObj = moment(value, [getDateTimeFormat(), moment.ISO_8601]);
  if (momentObj.isValid()) {
    // format to specified format
    return momentObj.format(getDateFormat());
  }
};

export const formattedDateToDate = (value) => {
  // parse specified format or ISO_8601
  const momentObj = moment(value, [getDateTimeFormat(), moment.ISO_8601]);
  if (momentObj.isValid()) {
    // return date object
    return momentObj.toDate();
  }
}

export const getDates = () => {
  const from = new Date(2020, 1, 19); // 2020.02.19
  const to = new Date();

  let current = new Date(from);

  const dates = [];

  while (current <= to) {
    dates.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }

  return {
    minDate: moment(from).format("YYYY-MM-DD"),
    maxDate: moment(to).format("YYYY-MM-DD"),
    dates: dates
  };
};
